
import { Button } from "@/components/ui/button";
import { CheckCircle, RefreshCw } from "lucide-react";

interface NotificationSettingsHeaderProps {
  settingsCount: number;
  onRefresh: () => void;
}

export const NotificationSettingsHeader = ({ settingsCount, onRefresh }: NotificationSettingsHeaderProps) => {
  return (
    <div className="flex items-center justify-between mb-4">
      <div className="flex items-center gap-2">
        {settingsCount > 0 ? (
          <>
            <CheckCircle className="w-4 h-4 text-green-600" />
            <p className="text-sm text-gray-600">عدد الإعدادات: {settingsCount}</p>
          </>
        ) : (
          <p className="text-sm text-orange-600 font-medium">لم يتم العثور على إعدادات</p>
        )}
      </div>
      <Button variant="outline" size="sm" onClick={onRefresh}>
        <RefreshCw className="w-4 h-4 mr-1" />
        تحديث
      </Button>
    </div>
  );
};
